import { Form, Row } from 'antd';
import React, { useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import CheckboxComponent from 'components/atoms/CheckboxComponent';
import Paragraph from 'components/atoms/Paragraph';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import { dokumentOsobyApi } from 'services/dokumenty/smlouva';

interface IPredmet {
    isDLT?: boolean;
    nextStep: () => void;
    prevStep: () => void;
    zadostID: number;
}

const Predmet: React.FC<IPredmet> = ({ isDLT, nextStep, prevStep, zadostID }) => {
    const [form] = Form.useForm();
    const [isChecked, setIsChecked] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setLoading(true);
        dokumentOsobyApi(zadostID, true)
            .then(
                resp =>
                    resp.osoby.filter(e => e.podepisuje).length &&
                    (setIsChecked(true),
                    form.setFieldsValue({
                        souhlas: true
                    }))
            )
            .finally(() => setLoading(false));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <LoadingWrapper loading={loading}>
            <FormWrapper outForm={form} onFinish={() => {}}>
                {isDLT ? (
                    <>
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_I"
                            style={{
                                display: 'block',
                                fontWeight: 'bold'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_I1"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_I2"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_II"
                            style={{
                                display: 'block',
                                fontWeight: 'bold',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_II1"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_II2"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_III"
                            style={{
                                display: 'block',
                                fontWeight: 'bold',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_III1"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_III2"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_III3"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_III4"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_IV"
                            style={{
                                display: 'block',
                                fontWeight: 'bold',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_IV1"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_IV2"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_IV3"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_IV4"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_IV5"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_V"
                            style={{
                                display: 'block',
                                fontWeight: 'bold',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_V1"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VI"
                            style={{
                                display: 'block',
                                fontWeight: 'bold',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VI1"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VI2"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VI3"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VI4"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VI5"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VI6"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII"
                            style={{
                                display: 'block',
                                fontWeight: 'bold',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII1"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII1A"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII1B"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII2"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII3"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII3A"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII3B"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII3C"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII3D"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII3E"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII3F"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VIII"
                            style={{
                                display: 'block',
                                fontWeight: 'bold',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VIII1"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VIII2"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                    </>
                ) : (
                    <>
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TITLE"
                            style={{
                                display: 'block',
                                fontWeight: 'bold'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_I1"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_I2"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_II"
                            style={{
                                display: 'block',
                                fontWeight: 'bold',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_II1"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_II2"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_III"
                            style={{
                                display: 'block',
                                fontWeight: 'bold',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_III1"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_III1A"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_III1B"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_III2"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_III3"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_III4"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_IV"
                            style={{
                                display: 'block',
                                fontWeight: 'bold',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_IV1"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_IV2"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_IV3"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_IV4"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_IV5"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_IV6"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_V"
                            style={{
                                display: 'block',
                                fontWeight: 'bold',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_V1"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VI"
                            style={{
                                display: 'block',
                                fontWeight: 'bold',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VI1"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VI2"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VI3"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VI4"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VI5"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VI6"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VI7"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VII"
                            style={{
                                display: 'block',
                                fontWeight: 'bold',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VII1"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VII1A"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VII1B"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VII2"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VII3"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VII3A"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VII3B"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VII3C"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VII3D"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VIII"
                            style={{
                                display: 'block',
                                fontWeight: 'bold',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VIII1"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENTY_SLOUVA_PREDMET_TEXT_VIII2"
                            style={{
                                display: 'block'
                            }}
                        />
                    </>
                )}

                <Row
                    style={{
                        marginBottom: 4,
                        marginTop: 26
                    }}
                >
                    <CheckboxComponent
                        name="souhlas"
                        checkboxText={<TranslateText>POTVRZENI_CHECKBOX</TranslateText>}
                        onChange={() => setIsChecked(pv => !pv)}
                        checked={isChecked}
                    />
                </Row>
                <Row className="button-row">
                    <ButtonComponent
                        buttontext="ZPET"
                        type="default"
                        onClick={() => prevStep()}
                        id="isinPokracovatBtn"
                    />
                    <ButtonComponent
                        buttontext="POKRACOVAT"
                        onClick={() => nextStep()}
                        id="isinPokracovatBtn"
                        disabled={!isChecked}
                    />
                </Row>
            </FormWrapper>
        </LoadingWrapper>
    );
};

export default Predmet;
